import React, { useState, useEffect, useContext } from 'react';
import WIOwnership from 'src/models/tract_detail/WIOwnership';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Owner from 'src/models/tract_detail/Owner';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import WIOwnershipCard from './WIOwnershipCard.redesign';
import { UseFormMethods } from 'react-hook-form';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import LeaseholdOwnership from 'src/models/leasehold/LeaseholdOwnership';
import MathUtil from 'src/util/MathUtil';

interface IWorkingInterestListProps extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'getValues' | 'watch' | 'setValue'>> {
    owners: Array<Owner>;
    wiOwnerships: Array<WIOwnership>;
    isGovStateBlm: boolean;
    royalty: number;

    setDialogShowing: (dialogName: string) => void;
    tryAddWI: () => void;
    onAddORRI: (parentOwnershipId: number) => void;
    onCopyORRI: (ownershipId: number) => void;
    onDeleteORRI: (ownershipId: number) => void;
    deleteLeaseholdOwnership: (leaseholdOwnershipId: number) => void;
    openOwnershipNotes: (ownershipId: number) => void;
}

const WorkingInterestList = (props: IWorkingInterestListProps) => {
    const [leaseholdOwnershipId, setLeaseholdOwnershipId] = useState(0);
    const [wiTotal, setWITotal] = useState(0);
    const appContext = useContext<IAppContextState>(AppContext);

    const onDeleteLeaseholdOwnership = (id: number) => {
        setLeaseholdOwnershipId(id);
        props.setDialogShowing(DialogList.CONFIRM_LEASEHOLD_OWNERSHIP_DELETE);
    };

    const handleWIInterestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const values = props.getValues();
        const wiOwnerships: Array<WIOwnership> = values?.leasehold?.leaseholdOwnerships;
        if (wiOwnerships) {
            let total = 0;
            wiOwnerships.forEach((wi) => {
                total += parseFloat(wi.decimalInterest + '') || 0;
            });
            setWITotal(total);
        }
        const royalty = parseFloat(values?.leasehold?.royalty + '') || 0;

        (wiOwnerships as unknown as LeaseholdOwnership[])?.forEach((lo: LeaseholdOwnership, i: number) => {
            const orriBurden = lo?.orriOwnerships?.reduce((acc: number, curr: WIOwnership) => acc + (parseFloat(curr.decimalInterest + '') || 0), 0);
            props.setValue(`leasehold.leaseholdOwnerships[${i}].orriInterest`, (MathUtil.cleanNumber(orriBurden || 0)));
            props.setValue(
                `leasehold.leaseholdOwnerships[${i}].nriInterest`,
                MathUtil.cleanNumber(((1 - royalty) * lo?.decimalInterest || 0) - ((orriBurden || 0) * lo?.decimalInterest || 0))
            );
        });
    };

    // const [count, setCount] = useState(0);

    // React.useEffect(() => {

    //     console.log('useEffeect props.watch', props.watch());

    //     if (count > 50) {
    //         return;
    //     } else {
    //         setCount(currCount => currCount + 1);
    //     }

    //     const formState = props.getValues();

    //     const royalty = parseFloat(formState?.leasehold?.royalty + '') || 0;

    //     formState?.leasehold?.leaseholdOwnerships?.forEach((lo: LeaseholdOwnership, i: number) => {
    //         const orriBurden = lo?.orriOwnerships?.reduce((acc: number, curr: WIOwnership) => acc + (parseFloat(curr.decimalInterest + '') || 0), 0);
    //         props.setValue(`leasehold.leaseholdOwnerships[${i}].orriInterest`, orriBurden);
    //         props.setValue(`leasehold.leaseholdOwnerships[${i}].nriInterest`, MathUtil.cleanNumber((1 - royalty) * lo?.decimalInterest - (orriBurden || 0)));
    //     });
    // }, [props.wiOwnerships]);

    // TODO: really hacky and questionable, Need to do deep dive on watch and figure out best practices for this. (watch in parent and sub compoments)
    useEffect(() => {
        console.log('calc useeffect');
        if (props.wiOwnerships?.length > 0) {
            setWITotal(Number(MathUtil.cleanNumber(props.wiOwnerships.reduce((acc, curr) => acc + curr.decimalInterest, 0))));

            props.wiOwnerships?.forEach((lo: WIOwnership, i: number) => {
                const orriBurden = lo?.orriOwnerships?.reduce(
                    (acc: number, curr: WIOwnership) => acc + (parseFloat(curr.decimalInterest + '') || 0),
                    0
                );
                // TODO: hacky, not sure why this is needed.
                setTimeout(() => {
                    props.setValue(`leasehold.leaseholdOwnerships[${i}].orriInterest`, MathUtil.cleanNumber(orriBurden || 0));
                    props.setValue(
                        `leasehold.leaseholdOwnerships[${i}].nriInterest`,
                        MathUtil.cleanNumber(((1 - props.royalty) * lo?.decimalInterest || 0) - ((orriBurden || 0) * lo?.decimalInterest || 0))
                    );
                }, 0);
            });
        } else {
            setWITotal(0);
        }
    }, [props.wiOwnerships, props.royalty]);

    const card = (wi: WIOwnership, index: number) => {
        return (
            <div key={index} style={{ width: '100%', margin: 0 }}>
                <WIOwnershipCard
                    ownership={wi}
                    owner={props.owners.find((o) => o.ownerLookUpId === wi.ownerLookUpId)}
                    index={index}
                    owners={props.owners}
                    addORRI={props.onAddORRI}
                    copyORRI={props.onCopyORRI}
                    deleteORRI={props.onDeleteORRI}
                    deleteLeaseholdOwnership={onDeleteLeaseholdOwnership}
                    showDialog={props.setDialogShowing}
                    openOwnershipNotes={props.openOwnershipNotes}
                    register={props.register}
                    errors={props.errors}
                    onWIInterestChange={handleWIInterestChange}
                    namePrefix={'leasehold.leaseholdOwnerships'}
                />
            </div>
        );
    };

    const interestStatus = () => {
        const wi = parseFloat(wiTotal + '');
        if (wi < 1) {
            return 'low';
        }
        if (wi === 1) {
            return 'good';
        }
        if (wi > 1) {
            return 'high';
        }
        return 'good';
    };

    return (
        <>
            <div style={{ width: '100%' }}>
                <div className="wi-info ownership-list">
                    <div className={`totals interest-status-${interestStatus()} | RI ${props?.getValues('leasehold.royalty')}`}>
                        <div className="mr-1">{props.isGovStateBlm ? 'Total Operating Rights Interest' : 'Total Working Interest'}</div>
                        <div>
                            <span>{MathUtil.cleanNumber(wiTotal)}</span>
                            {/* <button onClick={calcWITotal}>Click me</button> */}
                        </div>
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                        <Button
                            text={props.isGovStateBlm ? 'Add OR' : 'Add WI'}
                            size="medium"
                            intent="primary"
                            onClick={() => props.tryAddWI()}
                            disabled={appContext.leaseholdId > 0 ? false : true}
                        />
                    </div>
                </div>
            </div>
            {props.owners && props.wiOwnerships &&
                                                    <CardContainer
                                                        style={{ width: '100%' }}
                                                    >
                                                        {props.wiOwnerships.map(card)}
                                                    </CardContainer>}
            <Dialog
                title={props.isGovStateBlm ? 'Confirm Delete Operating Rights Interest' : 'Confirm Delete Working Interest'}
                dialogName={DialogList.CONFIRM_LEASEHOLD_OWNERSHIP_DELETE}
            >
                <h3>Are you sure want to permanetly delete this {props.isGovStateBlm ? 'OR' : 'WI'} record?</h3>
                <Button text="Confirm Delete" size="medium" intent="primary" onClick={() => props.deleteLeaseholdOwnership(leaseholdOwnershipId)} />
            </Dialog>
        </>
    );
};

export default WorkingInterestList;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/WorkingInterestList.tsx